import { ref } from 'vue'

const KEY = 'xp-crt'

function readStored(): boolean {
  try {
    if (typeof localStorage === 'undefined') return true
    // ON by default; only an explicit '0' disables it.
    return localStorage.getItem(KEY) !== '0'
  } catch {
    return true
  }
}

export const crtEnabled = ref<boolean>(readStored())

export function setCrt(on: boolean): void {
  crtEnabled.value = on
  try {
    localStorage.setItem(KEY, on ? '1' : '0')
  } catch {
    // storage unavailable — session-only
  }
}

export function toggleCrt(): void {
  setCrt(!crtEnabled.value)
}
